import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Bare application root - all chrome lives in routed components. The shell (`./shell/shell.component`)
 * is a routed layout loaded only for in-shell routes, so `/login` renders the standalone centred
 * card without the left rail, top bar or toaster host.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
